import api from "../utils/api";
import { isGuid } from "../utils/string";


export const get = ({ staffUuid, personUuid, caseUuid, uuid, startDate, endDate }) => async () => {
    try {
        let modifications = "";
        const pivot = isGuid(staffUuid) ? "/staff" : isGuid(personUuid) ? "/person" : isGuid(caseUuid) ? "/case" : "";
        const finalUuid = isGuid(staffUuid) ? staffUuid : isGuid(personUuid) ? personUuid : isGuid(caseUuid) ? caseUuid : uuid;
        if (startDate && endDate) modifications += `/r/${startDate}/${endDate}`;

        const res = await api.get(`/staff/expenses${pivot}/i/${finalUuid}${modifications}`);
        
        return res.data;
    } catch (err) {
        return { success: false, error: err?.response?.data?.error || err };
    }
}

export const save = ({ uuid,
    caseUuid,
    personUuid,
    staffUuid,
    expended,
    gross,
    writeOff,
    net,
    notes,
    merchant,
    vendorUuid,
    checkNumber,
    checkDate
}) => async () => {
    try {
        const res = await api.post(`/staff/expenses`, {
            uuid,
            caseUuid,
            personUuid,
            staffUuid,
            expended,
            gross,
            writeOff,
            net,
            notes,
            merchant,
            vendorUuid,
            checkNumber,
            checkDate
        });
        return res.data;
    } catch (error) {
        return { success: false, error: error?.response?.data?.error || error };
    }
}
